import { IrisBase } from './IrisBase';

export interface IIrisContainerConstParam {
    data_type:string|null
    gli_key:string|null
    data:any
}

export class IrisContainer<Tiris extends IrisBase>  {
            
    public data_type:string|null
    public gli_key:string|null
    public data:Tiris
    
    constructor({data_type,gli_key,data }:IIrisContainerConstParam, factory:(data:any)=>Tiris) {        
        this.data_type = data_type        
        this.gli_key = gli_key                
        this.data = factory(data)
    }
}
